import { ChangeDetectionStrategy, Component, ElementRef, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { NgOtpInputComponent } from 'ng-otp-input';
import { focusFirstOtpInput } from '../focus-otp';


@Component({
  selector: 'app-totp-validate',
  standalone: false,
  templateUrl: './totp-validate.component.html',
  styleUrl: './totp-validate.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TotpValidateComponent implements OnInit, OnDestroy {

  loginTitle: string = "Enter the token";
  errorMessage: string = "";

  token = '';
  // Skip the code on this device for 30 days (see trusted-device.ts)
  rememberDevice = false;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput!: NgOtpInputComponent; //ng-otp-input
  config = {
    allowNumbersOnly: true,
    length: 6,
    inputStyles: {
      width: '40px',
      height: '50px',
    }
  };

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TotpValidateComponent>,
    host: ElementRef<HTMLElement>) {
    focusFirstOtpInput(dialogRef, host);
  }

  ngOnInit(): void {
    console.error('TotpValidateComponent -> ngOnInit');
  }

  ngOnDestroy(): void {
    console.warn('TotpValidateComponent -> ngOnDestroy')
  }
  
  onOtpChange(otp: any) {
    this.token = otp ?? '';
  }

  paste(){
    console.warn('TotpValidateComponent -> paste') 

    navigator.clipboard.readText()
    .then(
      (text: string) => {
        this.ngOtpInput.setValue(text)
          this.token = text.replace(/\D/g, '').slice(0, 6);
        this.confirm()
      })
    .catch(error => {
        console.error('Cannot read clipboard text: ', error)
    })
  }

  confirm() {
    if (!/^\d{6}$/.test(this.token)) {
      this.errorMessage = 'Informe o código de seis dígitos.';
      return;
    }

    this.dialogRef.close({ code: this.token, rememberDevice: this.rememberDevice });

  }
}
